import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Key, ShieldCheck } from "@phosphor-icons/react";

export default function ForcePassword() {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 6) return toast.error("Nouveau mot de passe : 6 caractères minimum");
    setSaving(true);
    try {
      await api.post("/auth/change-password", f);
      toast.success("Mot de passe défini");
      window.location.reload();
    } catch (err) {
      toast.error(formatApiError(err));
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/30">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center">
            <ShieldCheck size={22} weight="fill" className="text-primary-foreground" />
          </div>
          <div>
            <div className="font-heading font-extrabold text-lg leading-none">Sécurisez votre compte</div>
            <div className="text-xs text-muted-foreground mt-1">Définissez un nouveau mot de passe pour continuer.</div>
          </div>
        </div>
        <form onSubmit={submit} className="border border-border rounded-lg bg-background p-6 space-y-4">
          <div className="space-y-1.5">
            <Label>Mot de passe temporaire actuel</Label>
            <Input type="password" data-testid="force-current-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required />
          </div>
          <div className="space-y-1.5">
            <Label>Nouveau mot de passe</Label>
            <Input type="password" data-testid="force-new-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required />
          </div>
          <Button type="submit" disabled={saving} data-testid="force-save-button" className="w-full">
            <Key size={16} className="mr-2" /> {saving ? "…" : "Définir et continuer"}
          </Button>
        </form>
      </div>
    </div>
  );
}
